import { render, staticRenderFns } from "./DiscountPolicy.vue?vue&type=template&id=64f5ced4&scoped=true&"
import script from "./DiscountPolicy.vue?vue&type=script&lang=js&"
export * from "./DiscountPolicy.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPolicy.vue?vue&type=style&index=0&id=64f5ced4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5ced4",
  null
  
)

export default component.exports